import React from 'react';

const NumberFormatter = ({ number }) => {
  const formattedNumber = number.toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return <div>{formattedNumber}</div>;
};

export default NumberFormatter;